import React from 'react';

const PreventingPKD = () => {
  return (
    <section className="section prevention-section">
      <div className="container">
        <h2 className="section-title">Preventing PKD for Future Generations</h2>

        <div className="info-card wide-card">
          <h3 className="card-title">Understanding PGD and IVF</h3>
          <div className="pgd-ivf-details">
            <div>
              <h4>What is IVF?</h4>
              <p>In vitro fertilization (IVF) is a process where eggs are retrieved from the ovaries and fertilized with sperm in a laboratory setting to create embryos.</p>
            </div>
            <div>
              <h4>What is PGD?</h4>
              <p>Preimplantation Genetic Diagnosis involves testing embryos for specific genetic conditions before implantation. Only embryos without the PKD mutation are selected for transfer.</p>
            </div>
            <div>
              <h4>How PGD & IVF help PKD families?</h4>
              <p>Provides information and reassurance before pregnancy begins. Helps break the cycle of the disease in families. Gives parents the chance to have a child without inheriting PKD.</p>
            </div>
          </div>
        </div>

        <div className="grid-container-3">
          <div className="info-card">
            <h4 className="card-title">Why this matters?</h4>
            <ul>
              <li>Prevents PKD transmission to children</li>
              <li>Gives families reproductive choices</li>
              <li>Reduces genetic burden on future generations</li>
              <li>Provides peace of mind for parents</li>
            </ul>
          </div>
          <div className="info-card">
            <h4 className="card-title">Key Considerations</h4>
            <ul>
              <li>Cost and insurance coverage varies</li>
              <li>Limited availability in some regions</li>
              <li>Requires genetic counseling support</li>
              <li>Emotional and ethical considerations</li>
            </ul>
          </div>
          <div className="info-card key-takeaway-card">
            <h4 className="card-title">Key Takeaways</h4>
            <p>IVF with PGD offers hope for families affected by PKD to have children free from the condition. While complex, this technology provides a path to break the cycle of genetic transmission.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PreventingPKD;